var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOther(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_82:238)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3927 23.6492C9.63476 23.6492 8.20419 22.2186 8.20419 20.4607C8.20419 18.7028 9.63476 17.2722 11.3927 17.2722C13.1506 17.2722 14.5812 18.7028 14.5812 20.4607C14.5812 22.2186 13.1506 23.6492 11.3927 23.6492ZM11.3927 18.335C10.2204 18.335 9.26702 19.2884 9.26702 20.4607C9.26702 21.633 10.2204 22.5864 11.3927 22.5864C12.565 22.5864 13.5183 21.633 13.5183 20.4607C13.5183 19.2884 12.565 18.335 11.3927 18.335Z",
    fill: "#242731"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9581 23.6492C19.2002 23.6492 17.7697 22.2186 17.7697 20.4607C17.7697 18.7028 19.2002 17.2722 20.9581 17.2722C22.7161 17.2722 24.1466 18.7028 24.1466 20.4607C24.1466 22.2186 22.7161 23.6492 20.9581 23.6492ZM20.9581 18.335C19.7858 18.335 18.8325 19.2884 18.8325 20.4607C18.8325 21.633 19.7858 22.5864 20.9581 22.5864C22.1304 22.5864 23.0838 21.633 23.0838 20.4607C23.0838 19.2884 22.1304 18.335 20.9581 18.335Z",
    fill: "#242731"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5235 23.6492C28.7656 23.6492 27.3351 22.2186 27.3351 20.4607C27.3351 18.7028 28.7656 17.2722 30.5235 17.2722C32.2815 17.2722 33.712 18.7028 33.712 20.4607C33.712 22.2186 32.2815 23.6492 30.5235 23.6492ZM30.5235 18.335C29.3512 18.335 28.3979 19.2884 28.3979 20.4607C28.3979 21.633 29.3512 22.5864 30.5235 22.5864C31.6958 22.5864 32.6492 21.633 32.6492 20.4607C32.6492 19.2884 31.6958 18.335 30.5235 18.335Z",
    fill: "#242731"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_82:238"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.5079,
    height: 25.5079,
    fill: "white",
    transform: "translate(8.20419 7.70685)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOther);
export default __webpack_public_path__ + "static/media/Other.0ac30fb6f0a28c9efd944a4ef0390cd4.svg";
export { ForwardRef as ReactComponent };